module.exports = __webpack_public_path__ + "static/media/facebook-icon-hover.1d203f04.svg";